<template>
    <div>
        <div class="subcaption text-grey-600 px-3">{{ props.contents.placeHolders.topStations }}</div>
        <div v-for="station in stations">
            <div
                class="subcaption text-grey-900 cursor-pointer py-1 item px-3 d-flex justify-content-between align-items-center"
                @click="handleSelect(station)"
                :class="{
                    'bg-primary-blue selected-item': isSelected(station.type, station.id, props.store)
                }"
            >
                <span>{{ station.label }}</span>
                <template v-if="isSelected(station.type, station.id, props.store)">
                    <CloseButton />
                </template>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import {computed, ComputedRef} from "vue"

// logic
import {getDefaultTopStationIds, processStationIdArr} from '../../../logic/getTopStations'
import setSelected from '../../../logic/setSelected'
import unselect from '../../../logic/unselect'
import isSelected from '../../../logic/isSelected'

// state
import {AutocompleteState} from '../../../state/autocompleteState'

// enums
import { SeFields } from '../../../enums/seFields'
import { StationType } from '../../../enums/stationType'

// components
import CloseButton from "../../../components/close-button.vue"
import { TopStation } from '../../../classes/TopStation'
import { GeoParentStation, GeoStation } from "../../../types/geodata"

const stations: ComputedRef<TopStation[]> = computed(() => {
    const available = props.store?.data?.available
    const geoData = props.store?.data?.geoData
    if (!available || !geoData) return []

    const stationsMap: { [id: string]: GeoStation } = geoData.stationsMap
    const parentStationsMap: { [id: string]: GeoParentStation } = geoData.parentStationsMap

    let topStations: TopStation[]
    if (props.customTopStations) topStations = processStationIdArr(props.customTopStations, stationsMap, parentStationsMap)
    else topStations = processStationIdArr(getDefaultTopStationIds(props.locale), stationsMap, parentStationsMap)

    return topStations.filter((station: TopStation) => {
        if (station.type === StationType.PARENT_STATION) {
            return !!available.parentStationsMap?.[station.id]
        }
        if (station.type === StationType.STATION) {
            return !!available.stationsMap?.[station.id]
        }
        return true
    })
})


// props
const props = defineProps<{
    locale: string
    se: any
    contents: any
    store: any
    state: AutocompleteState
    customTopStations?: number[]
}>()

// Logic

// Methods
const handleSelect = (station: any) => {
    const { label, type } = station
    if (isSelected(type, station.id, props.store)) {
        handleUnselect(station)
    } else {
        select(station)
    }
}

const select = (station: any) => {
    const { label, type } = station
    setSelected(type, station.id, station.label, props.store)
    if (type === SeFields.STATION) {
        props.store.libs.se.batch(() => {
            props.se.setFieldValue(type, [station.id])
            props.store.libs.se.setFieldValue(SeFields.PARENT_STATION, undefined)
            props.store.libs.se.setFieldValue(SeFields.REGION, undefined)
            props.store.libs.se.setFieldValue(SeFields.DOMAINS, undefined)
        })
    }
    if (type === SeFields.PARENT_STATION) {
        props.store.libs.se.batch(() => {
            props.se.setFieldValue(type, [station.id])
            props.store.libs.se.setFieldValue(SeFields.STATION, undefined)
            props.store.libs.se.setFieldValue(SeFields.REGION, undefined)
            props.store.libs.se.setFieldValue(SeFields.DOMAINS, undefined)
        })
    }
}

const handleUnselect = (station: any) => {
    const { label, type } = station
    unselect(props.store)
    if (type === SeFields.STATION) {
        props.store.libs.se.setFieldValue(SeFields.STATION, undefined)
    }
    if (type === SeFields.PARENT_STATION) {
        props.store.libs.se.setFieldValue(SeFields.PARENT_STATION, undefined)
    }
}
</script>
